export default __webpack_public_path__ + "static/media/misc-drawerA-480w.3fbbca24.avif";